export default __webpack_public_path__ + "static/media/user-gray-icon.49e006db.svg";